export default __webpack_public_path__ + "static/media/patrocinante.6a1afa9b.svg";